// extracted by mini-css-extract-plugin
export var completionBody = "_ee-2";
export var completionCard = "_ee-0";
export var completionFooter = "_ee-3";
export var completionTitle = "_ee-1";